import React from "react";
import Subscriber from "../../subscriber.class";
// import "./Footer.css";
import Translations from "../../services/translation";
import User from "../../services/user";
import Events from "../../services/events.service";
import LogoutConfirmationModal from "../LogoutConfirmationModal/LogoutConfirmationModal";
import red_logo from "../../assets/img/new_onboarding/virgin-mobile-logo.svg";
import carbon from "../../assets/img/carbon-neutral.svg";
import Storage from "../../services/storage.service";
import Settings from "../../services/settings";
export default class Footer extends Subscriber {
  state = {
    routeTo: null,
    showConfirmModal: false,
    loading_text: "",
  };

  componentDidMount() {
    this.subscriptions.push(
      Storage.get_obsrv("loading_text").subscribe((loading_text) => {
        this.setState({
          loading_text: loading_text,
        });
      }),
    );
  }

  logout = (btn) => {
    if (btn === "confirm") {
      this.setState({
        showConfirmModal: false,
      });
      User.logout({
        callee: "user-initiated",
      });
    }
    this.setState({
      showConfirmModal: false,
    });
  };

  showLogoutConfirmationModal = () => {
    this.setState({
      showConfirmModal: true,
    });
  };

  render() {
    let url = Settings.logo_link;
    if (this.state.loading_text) {
      return "";
    }

    let strings = Translations["keys"][Translations.activeLang];
    // let call_us_number = "tel:800165";
    // let callus = (
    //   <div className="ftr-callus" id="link_callus" onClick={phonePlaceHolder}>
    //     <img src={phoneHandsetIcn} alt="" />{" "}
    //     <span className="bold" id="phonePlaceHolder">
    //       {strings["FOOTER_CALL_US"]}
    //     </span>{" "}
    //     <span className="light">{strings["FOOTER_247_SUPPORT"]}</span>
    //   </div>
    // );
    // if (Globals.Helpers.isMobile()) {
    //   callus = (
    //     <a href={call_us_number} id="link_callus" className="ftr-callus">
    //       <img src={phoneHandsetIcn} alt="" />{" "}
    //       <span className="bold">Call us</span>{" "}
    //       <span className="light">{strings["FOOTER_247_SUPPORT"]}</span>
    //     </a>
    //   );
    // }

    let logout_link = "";
    if (User.isLoggedInProper()) {
      logout_link = (
        <li>
          <span
            className="footer-lnk"
            id="link_logout"
            onClick={this.showLogoutConfirmationModal}>
            {strings["LOGOUT"]}
          </span>
        </li>
      );
    }

    let modalContent = null;
    if (this.state.showConfirmModal) {
      modalContent = <LogoutConfirmationModal confirmLogout={this.logout} />;
    }

    return (
      <>
        <footer>
          {this.state.routeTo}
          <div className="vmo-centered-with-side">
            <div className="copywrite">
              <div className="vmo-brand-logo vmo-footer-brand-logo">
                <img alt="" className="vmo-blink" src={red_logo} />
              </div>
              {strings["FOOTER_COPYRIGHTS_1"]}
              <br />
              {strings["FOOTER_COPYRIGHTS_2"]}
            </div>
            <div className="carbon-neutral">
              <div className="vmo-brand-logo vmo-footer-carbon-logo">
                <img
                  alt="carbon neutral"
                  className="vmo-carbon-neutral"
                  src={carbon}
                />
              </div>
              {strings["FOOTER_CARBON_NEUTRAL_TEXT"]}
            </div>
            <ul className="footer-lnks">
              <li
                onClick={() => {
                  Events.when_user_clicks_on_footer_links(
                    strings["FOOTER_HELP_LINK"],
                  );
                }}>
                <a
                  href={`${url}help/`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="footer-lnk"
                  id="link_help">
                  {strings["FOOTER_HELP_LINK"]}
                </a>
              </li>
              <li
                onClick={() => {
                  Events.when_user_clicks_on_footer_links(
                    strings["FOOTER_LEGAL_LINK"],
                  );
                }}>
                <a
                  href={`${url}legal-stuff/`}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="footer-lnk"
                  id="link_legal_stuff">
                  {strings["FOOTER_LEGAL_LINK"]}
                </a>
              </li>
              {logout_link}
            </ul>
          </div>
        </footer>

        {modalContent}
      </>
    );
  }
}
